import * as bootstrap from 'bootstrap';

// GSAP
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { ScrollSmoother } from "gsap/ScrollSmoother";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";
import { SplitText } from "gsap/SplitText";

// THEME MODULES
import { bootstrapTweaks } from './modules/bootstrap-tweaks.js';
import DataAttrTransformer from './modules/data-attr-transformer';
import Carousels from './modules/carousels.js';
import setupAnimationUtilities from './modules/animation-utilities.js';
import { local } from './modules/local-storage';
import { utils } from './modules/utils.js';

// Register Boostrap
window.bootstrap = bootstrap;

// Add GSAP to window and Register plugins
window.gsap = gsap;
window.ScrollTrigger = ScrollTrigger;
window.ScrollSmoother = ScrollSmoother;
window.ScrollToPlugin = ScrollToPlugin;
window.SplitText = SplitText;
gsap.registerPlugin(ScrollTrigger, ScrollToPlugin, SplitText);

const {select, selectAll} = utils

// Trying to load in footer so this is not needed
// If bugs arise you can wrap everything below
// jQuery(document).ready(($) => {  });


// --- BEGIN CUSTOM JAVASCRIPT --- //


// UTILITY FOR TRANSFORMING CLASSES TO ATTRIBUTES - disable if not using
DataAttrTransformer()

// TRANSPORT MODALS TO BODY AND HANDLE SCROLL PAUSING
bootstrapTweaks.handleModals(true)

// FLOATING LABELS FOR FORMS - disable if not using
bootstrapTweaks.addFloatingLabelsToForms(jQuery)

// INITIALIZE ANY SPLIDE CAROUSELS
Carousels()

// Only proceed with ScrollSmoother initialization if it's not a touch device
if (!utils.isTouchDevice()) {
  gsap.registerPlugin(ScrollSmoother);

  // Dummy ScrollTrigger instance
  let dummytl = gsap.timeline({
    scrollTrigger: {
      trigger: 'body',
    }
  });

  var smoother = ScrollSmoother.create({
    wrapper: ".pd_ss_wrapper",
    content: ".pd_ss_inner",
    smooth: 0.7,
    effects: false,
    smoothTouch: 0.4,
    ignoreMobileResize: true,
    normalizeScroll: true,
  });

  window.pd_smoother = smoother;
}

// Use matchHeight for headers
function matchHeights() {
  const join = document.querySelector('.pd-join-shape');
  const logo = document.querySelector('.pd-join-logo');

  if (!join || !logo) return;

  // Aspect ratio of the SVG
  const pseudoAspectRatio = 1440 / 134;
  const joinWidth = join.offsetWidth;
  const pseudoHeight = joinWidth / pseudoAspectRatio;

  // Position the logo so its center aligns with the top of the shape
  const logoHeight = logo.offsetHeight;
  const offset = pseudoHeight + (logoHeight / 2);
  logo.style.top = `-${offset}px`;
}

function matchFooterHeight() {
  const footer = document.querySelector('footer');
  const firstArch = document.querySelector('.pd-arches');

  if (!footer || !firstArch) return;

  // Wait for the first arch to load, then set footer's min-height
  const img = firstArch.querySelector('img');
  if (img && !img.complete) {
    img.onload = () => {
      footer.style.minHeight = `${firstArch.offsetHeight}px`;
    };
    img.onerror = () => {
      console.error('Failed to load arch image.');
    };
  } else {
    footer.style.minHeight = `${firstArch.offsetHeight}px`;
  }
}

// Recreate Headroom with ScrollTrigger
const siteHeader = document.querySelector('.site-header');
let header_progress = 0;
let header_direction = 1;
ScrollTrigger.create({
  trigger: "#pd-main",
  start: "+=100",
  end: 'bottom bottom',
  onUpdate: function (self) {
    header_progress = self.progress.toFixed(2);
    header_direction = self.direction;
    if (header_progress == 0.00) {
      // scroll is at top
      siteHeader.classList.add('pd-top');
      siteHeader.classList.remove('pd-notTop');
      document.body.classList.remove('pd-is-scrolled');
    } else {
      // page has been scrolled
      siteHeader.classList.remove('pd-top');
      siteHeader.classList.add('pd-notTop');
      document.body.classList.add('pd-is-scrolled');
    }
    if (header_direction == -1) {
      // user is scrolling up
      siteHeader.classList.add('pd-pinned');
    } else {
      // user is scrolling down
      siteHeader.classList.remove('pd-pinned');

      // close menu on scroll down - optional
      if(select('.site-header').classList.contains('mobile-menu-open')){
        select('.pd-menu-trigger').click()
      }

    }
  }
});

// GSAP ScrollTo functionality
function scrollToTarget(target) {
  if (target) {
    // Check the window width and adjust the navOuterHeight accordingly
    const navOuterHeight = window.innerWidth <= 1200 ? 120 : 50;
    const yOffset =
      target.getBoundingClientRect().top + window.scrollY - navOuterHeight - 0;
    gsap.to(window, { scrollTo: yOffset, duration: 1, ease: "power2.inOut" });
  }
}

// Click event listener for anchor links using GSAP ScrollTo
document.querySelectorAll('a[href^="#"]').forEach((anchor) => {
  anchor.addEventListener("click", function (e) {
    e.preventDefault();
    if (this.getAttribute("href") !== "#") {
      const target = document.querySelector(this.getAttribute("href"));
      scrollToTarget(target);
    }
  });
});


setupAnimationUtilities()
matchHeights();
matchFooterHeight();

// Event listeners and triggers
window.addEventListener('load', () => {
  // On load functions
});

// Resize with debounce - Let's debounce our heavy lifts
window.addEventListener('resize', utils.debounce(() => {
  matchHeights();
  matchFooterHeight();

  if (!utils.isTouchDevice()) {
    ScrollTrigger.refresh();
  }
}, 250));


(() => {
  // Wait until the container exists, then run the original logic
  const run = () => {
    // ======== ORIGINAL LOGIC STARTS (unchanged) ========
    const MIN_DIGITS_TO_REVEAL = 2;

    const hasUserDigits = (val) => {
      const digits = (val || "").replace(/\D+/g, ""); // keep only 0-9
      return digits.length >= MIN_DIGITS_TO_REVEAL;
    };

    const attach = (el) => {
      if (!el || el._hasNumberHooked) return;
      el._hasNumberHooked = true;

      const sync = () => {
        el.setAttribute("data-has-number", hasUserDigits(el.value) ? "true" : "false");
      };

      ["input", "change", "keyup", "paste"].forEach(evt => el.addEventListener(evt, sync));
      setTimeout(sync, 0);
      setTimeout(sync, 50);
      setTimeout(sync, 200);
    };

    document.querySelectorAll(".momence-lead_form-field_input .form-control").forEach(attach);

    const mo = new MutationObserver((mutations) => {
      for (const m of mutations) {
        m.addedNodes && m.addedNodes.forEach(node => {
          if (!(node instanceof Element)) return;
          if (node.matches?.(".momence-lead_form-field_input .form-control")) attach(node);
          node.querySelectorAll?.(".momence-lead_form-field_input .form-control").forEach(attach);
        });
      }
    });
    mo.observe(document.documentElement, { childList: true, subtree: true });
    // ======== ORIGINAL LOGIC ENDS ========
  };

  const startWhenReady = () => {
    // If the container is already present, run immediately
    if (document.querySelector('.momence-lead_form-form_container')) {
      run();
      return;
    }
    // Otherwise, watch for it to appear
    const waitForContainer = new MutationObserver(() => {
      if (document.querySelector('.momence-lead_form-form_container')) {
        waitForContainer.disconnect();
        run();
      }
    });
    waitForContainer.observe(document.documentElement, { childList: true, subtree: true });
  };

  // Ensure DOM is parsed first
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', startWhenReady);
  } else {
    startWhenReady();
  }
})();


// Hamburger toggle
document.addEventListener("DOMContentLoaded", () => {
  const menuTrigger = document.querySelector(".pd-menu-trigger");
  
  if (!menuTrigger) return; // exit if element not found

  menuTrigger.addEventListener("click", () => {
    menuTrigger.classList.toggle("is-active");
  });
});










